"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4724],{

/***/ 59276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ RefrigeratedIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_AcUnitRounded__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84249);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13264);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72389);




var RootDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")({
    display: "flex",
    position: "absolute",
    right: "12px",
    bottom: "12px",
    width: "20px",
    height: "20px",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#2196F31A",
    borderRadius: "50%"
});
var RefrigeratedIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: "Producto refrigerado (2\xb0C - 8\xb0C)",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootDiv, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_AcUnitRounded__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                sx: {
                    fontSize: 16,
                    color: "#0D3C61"
                }
            })
        })
    });
};


/***/ }),

/***/ 97441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ ProductsList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/ProductsList.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "white",
    border: "1px solid #EAEAEA",
    borderRadius: "10px"
});
var SubTitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "14px",
    fontWeight: 500,
    color: "#414046",
    textAlign: "left",
    marginLeft: "12px",
    marginTop: "10px",
    marginBottom: "10px"
});
var DivisionLine = (0,styled/* default */.Z)("div")({
    height: "1px",
    backgroundColor: "#EAEAEA",
    width: "100%"
});

// EXTERNAL MODULE: ./src/screens/checkout/paymentSuccess/components/Item.tsx + 3 modules
var Item = __webpack_require__(39566);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/ProductsList.tsx







function ProductsList(param) {
    var isDelivery = param.isDelivery, orders = param.orders, insuranceInfo = param.insuranceInfo;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var findDetailsWithInsurance = function(orderDetails) {
        return orderDetails.filter(function(detail) {
            return detail.insurance;
        });
    };
    var findDetailsWithoutInsurance = function(orderDetails) {
        return orderDetails.filter(function(detail) {
            return !detail.insurance;
        });
    };
    var userSelectedInsurance = insuranceInfo === null || insuranceInfo === void 0 ? void 0 : insuranceInfo.insuranceId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootDiv, {
        children: orders === null || orders === void 0 ? void 0 : orders.map(function(order, i) {
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    isLocalVendor ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitleTypography, {
                        children: "Venta en Local"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubTitleTypography, {
                        children: [
                            orders.length > 1 ? "".concat(isDelivery ? "Entrega" : "Retiro", " N\xb0 ").concat(i + 1, ": ") : "".concat(isDelivery ? "Entrega" : "Retiro", ": "),
                            "".concat((0,utils/* getWeekdayName */.ng)(order.deliveryDate.replace(/-/g, "/")), " ").concat((0,utils/* extractShortDate */.Pb)((0,utils/* withoutTimezone */.ej)(order.deliveryDate.split(",")[0])))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DivisionLine, {}),
                    findDetailsWithInsurance(order === null || order === void 0 ? void 0 : order.orderDetails).length > 0 && userSelectedInsurance && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitleTypography, {
                                children: "Productos con cobertura de seguro"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DivisionLine, {})
                        ]
                    }),
                    findDetailsWithInsurance(order === null || order === void 0 ? void 0 : order.orderDetails).map(function(detail) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* Item */.c, {
                            product: detail.product,
                            price: detail.price,
                            quantity: detail.quantity,
                            loading: false,
                            insurance: detail.insurance,
                            type: detail.type ? String(detail.type) : null,
                            listPrice: Number(detail.listPrice)
                        }, "".concat(detail.id, "_").concat(detail.price, "_").concat(detail.quantity));
                    }),
                    findDetailsWithoutInsurance(order === null || order === void 0 ? void 0 : order.orderDetails).length > 0 && userSelectedInsurance && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitleTypography, {
                                children: "Productos sin cobertura de seguro"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DivisionLine, {})
                        ]
                    }),
                    findDetailsWithoutInsurance(order === null || order === void 0 ? void 0 : order.orderDetails).map(function(detail) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* Item */.c, {
                            product: detail.product,
                            price: detail.price,
                            quantity: detail.quantity,
                            loading: false,
                            insurance: detail.insurance,
                            type: detail.type ? String(detail.type) : null,
                            listPrice: Number(detail.listPrice)
                        }, "".concat(detail.id, "_").concat(detail.price, "_").concat(detail.quantity));
                    })
                ]
            }, order.id);
        })
    });
}


/***/ }),

/***/ 91345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ LoadingScreen; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/LinearProgress/LinearProgress.js + 1 modules
var LinearProgress = __webpack_require__(86070);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(26993);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/LoadingScreen.styles.ts



var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    alignItems: "center",
    justifyContent: "center",
    "@media (min-width: 900px)": {
        height: "calc(100vh - 100px)"
    }
});
var LoadingText = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.15px",
        color: "#414046",
        textAlign: "center",
        margin: "0 100px 45px 100px"
    }, theme.breakpoints.up(900), {
        margin: "0 300px 45px 300px"
    });
});
var LoadingImg = (0,styled/* default */.Z)("img")({
    width: "47.24px",
    marginBottom: "45px"
});
var LoadingBar = (0,styled/* default */.Z)(LinearProgress/* default */.Z)({
    width: "40%",
    height: "4px",
    borderRadius: "2px",
    backgroundColor: "#E5E5E5",
    "@media (min-width: 900px)": {
        width: "25%"
    }
});
var CancelButton = (0,styled/* default */.Z)(Button/* default */.Z)(function(param) {
    var disabled = param.disabled;
    return {
        padding: "10px 20px",
        marginTop: "20px",
        cursor: "pointer",
        borderRadius: "100px",
        color: "#FFFFFF",
        height: "42px",
        width: "199px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };
});
var CancelText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textDecoration: "none",
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px"
});


// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/LoadingScreen.tsx




function LoadingScreen(props) {
    var ref = (0,react.useState)(false), disabled = ref[0], setDisabled = ref[1];
    var redirectMessage = props.redirectMessage, isFintocSuccess = props.isFintocSuccess, showCancelButton = props.showCancelButton, handleCancel = props.handleCancel, isLocalVendor = props.isLocalVendor, isInsurance = props.isInsurance;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText, {
                children: isLocalVendor ? "Cargando..." : isFintocSuccess ? "Validando pago..." : redirectMessage ? "Redirigiendo..." : isInsurance ? "Confirmando..." : "Confirmando y realizando cobro..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingImg, {
                src: "/assets/images/creditCard.png"
            }),
            !disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar, {}),
            showCancelButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelButton, {
                variant: "contained",
                onClick: function() {
                    if (!disabled) {
                        setDisabled(true);
                        handleCancel();
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelText, {
                    children: disabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "Cancelando ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                color: "inherit",
                                size: 20
                            })
                        ]
                    }) : "Cancelar"
                })
            })
        ]
    });
}


/***/ }),

/***/ 39566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ Item; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/screens/product/utils/extractExtraInfo.tsx
var extractExtraInfo = __webpack_require__(73724);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentSuccess/styles/ItemDetails.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    minWidth: "100px",
    paddingBottom: 0,
    padding: "0 10px 0px 16px"
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "14px",
    fontWeight: 500,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});
var DetailsTextTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "12px",
    letterSpacing: "0.4px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    marginTop: "3px",
    color: "#757475",
    span: {
        color: "#414046"
    }
});
var DetailsPriceDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row"
});
var DetailsPriceTypographyBold = (0,styled/* default */.Z)(Typography/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "type";
    }
})(function(param) {
    var type = param.type;
    return {
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: "18px",
        letterSpacing: "0.16px",
        color: type == "normal" ? "#414046" : type == "insurance" ? "#731EFF" : "#CBCBCB",
        textDecoration: type == "strikethrough" ? "line-through" : "none"
    };
});
var DetailsPriceTypographyLight = (0,styled/* default */.Z)(Typography/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "type";
    }
})(function(param) {
    var type = param.type;
    return {
        fontFamily: "Poppins",
        fontWeight: type == "insurance" ? 500 : 300,
        fontSize: "12px",
        lineHeight: "18px",
        letterSpacing: "0.16px",
        color: type == "normal" ? "#414046" : type == "insurance" ? "#731EFF" : "#CBCBCB",
        textDecoration: type == "strikethrough" ? "line-through" : "none"
    };
});
var ColumnDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    width: "100%"
});


// EXTERNAL MODULE: ./src/screens/checkout/utils/discountTypeBanner.tsx
var discountTypeBanner = __webpack_require__(54773);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentSuccess/components/ItemDetails.tsx






var currFormat = new CurrencyFormatter/* CurrencyFormatter */.J();
function CartProductDetails(param) {
    var product = param.product, price = param.price, quantity = param.quantity, unitCopay = param.unitCopay, type = param.type, listPrice = param.listPrice, loading = param.loading;
    var ref, ref1, ref2, ref3, ref4;
    var hasInsurance = unitCopay >= 0;
    var hasDiscount = (product === null || product === void 0 ? void 0 : (ref = product.discount) === null || ref === void 0 ? void 0 : ref.price) > 0;
    var hasManualPrice = price !== (product === null || product === void 0 ? void 0 : product.price) && price !== (product === null || product === void 0 ? void 0 : (ref1 = product.discount) === null || ref1 === void 0 ? void 0 : ref1.price);
    var isMekiPriceDifferent = listPrice && listPrice > 0 ? listPrice : hasDiscount && !hasManualPrice || hasInsurance;
    var currentPrice = hasInsurance ? unitCopay : listPrice && listPrice > 0 ? price : product === null || product === void 0 ? void 0 : (ref2 = product.discount) === null || ref2 === void 0 ? void 0 : ref2.price;
    var realMekiPrice = listPrice && listPrice > 0 ? listPrice : hasInsurance || hasManualPrice || !hasDiscount ? price : Number(product === null || product === void 0 ? void 0 : (ref3 = product.discount) === null || ref3 === void 0 ? void 0 : ref3.listPrice);
    var discountType = type !== null && type !== void 0 ? type : product === null || product === void 0 ? void 0 : (ref4 = product.discount) === null || ref4 === void 0 ? void 0 : ref4.type;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductDetailsSkeleton, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                variant: "subtitle2",
                children: product.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsTextTypography, {
                color: "textSecondary",
                variant: "body2",
                children: (0,extractExtraInfo/* extractExtraInfo */.UD)(product)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsTextTypography, {
                color: "textPrimary",
                variant: "subtitle2",
                children: product.laboratory
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnDiv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsPriceTypographyBold, {
                                type: isMekiPriceDifferent ? "strikethrough" : "normal",
                                color: "textPrimary",
                                variant: "subtitle2",
                                children: quantity > 1 && "".concat(currFormat.format(realMekiPrice * quantity), "・")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceTypographyLight, {
                                type: isMekiPriceDifferent ? "strikethrough" : "normal",
                                color: "textPrimary",
                                variant: "subtitle2",
                                children: [
                                    "".concat(currFormat.format(realMekiPrice)),
                                    "/un"
                                ]
                            })
                        ]
                    }),
                    isMekiPriceDifferent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsPriceTypographyBold, {
                                type: "insurance",
                                color: "textPrimary",
                                variant: "subtitle2",
                                children: quantity > 1 && "".concat(currFormat.format(currentPrice * quantity), "・")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsPriceTypographyLight, {
                                type: "insurance",
                                color: "textPrimary",
                                variant: "subtitle2",
                                children: [
                                    "".concat(currFormat.format(currentPrice)),
                                    "/un"
                                ]
                            })
                        ]
                    }),
                    discountType && discountType != "REGULAR" && Object.values(discountTypeBanner/* DISCOUNT_TYPES */.v5).includes(discountType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(discountTypeBanner/* DiscountTypeContainer */._D, {
                        children: (0,discountTypeBanner/* discountText */.LT)(discountType)
                    })
                ]
            })
        ]
    });
}
var CartProductDetailsSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "text",
                width: "150px",
                height: "19px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "text",
                width: "150px",
                height: "19px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "text",
                width: "56px",
                height: "18px"
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentSuccess/styles/Item.styles.ts


var Item_styles_RootDiv = (0,styled/* default */.Z)("div")({
    width: "100%",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "row",
    padding: "12px",
    borderBottom: "1px solid #EAEAEA",
    alignItems: "center",
    height: "fit-content",
    position: "relative",
    ":last-child": {
        borderRadius: "0 0 10px 10px",
        borderBottom: "none"
    }
});
var ProductQuantity = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "0 20px"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(600), {
        padding: "0 5px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(500), {
        padding: "0 2px"
    }), _obj;
});
var VerticalLine = (0,styled/* default */.Z)("hr")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: "100%",
        margin: 0,
        border: "1px solid #EAEAEA",
        position: "absolute",
        marginLeft: "60px"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(600), {
        marginLeft: "30px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(500), {
        marginLeft: "20px"
    }), _obj;
});
var ImgDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "flex",
        maxWidth: "100px",
        minWidth: "100px",
        justifyContent: "center",
        marginLeft: "35px",
        height: "inherit",
        aspectRatio: "1",
        alignItems: "center"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(600), {
        maxWidth: "80px",
        minWidth: "80px"
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down(500), {
        maxWidth: "60px",
        minWidth: "60px"
    }), _obj;
});
var ImgProduct = (0,styled/* default */.Z)("img")({
    maxWidth: "100%",
    display: "block",
    maxHeight: "90%"
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/screens/checkout/components/RefrigeratedIcon.tsx
var RefrigeratedIcon = __webpack_require__(59276);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentSuccess/components/Item.tsx






function Item(param) {
    var product = param.product, price = param.price, quantity = param.quantity, insurance = param.insurance, type = param.type, listPrice = param.listPrice, loading = param.loading;
    var ref;
    var ref1 = (0,react.useState)(product.imagesUrl[0]), imageUrl = ref1[0], setImageUrl = ref1[1];
    var isRefrigerated = product === null || product === void 0 ? void 0 : (ref = product.metadata) === null || ref === void 0 ? void 0 : ref.refrigerated;
    var handleImageError = function() {
        setImageUrl("/assets/images/default.webp");
    };
    (0,react.useEffect)(function() {
        setImageUrl(product.imagesUrl[0]);
    }, [
        product.imagesUrl
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSkeleton, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item_styles_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductQuantity, {
                children: quantity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgDiv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgProduct, {
                    src: imageUrl,
                    onError: handleImageError
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalLine, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductDetails, {
                product: product,
                price: price,
                unitReimbursement: insurance === null || insurance === void 0 ? void 0 : insurance.unitReimbursement,
                unitDeductible: insurance === null || insurance === void 0 ? void 0 : insurance.unitDeductible,
                unitCopay: insurance === null || insurance === void 0 ? void 0 : insurance.unitCopay,
                quantity: quantity,
                type: type,
                listPrice: listPrice
            }),
            isRefrigerated && /*#__PURE__*/ (0,jsx_runtime.jsx)(RefrigeratedIcon/* RefrigeratedIcon */.x, {})
        ]
    });
}
var ItemSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item_styles_RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductQuantity, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: "9px",
                    height: "21px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgDiv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "rectangular",
                    width: "100%",
                    height: "100%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalLine, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductDetailsSkeleton, {})
        ]
    });
};


/***/ }),

/***/ 54773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LT": function() { return /* binding */ discountText; },
/* harmony export */   "_D": function() { return /* binding */ DiscountTypeContainer; },
/* harmony export */   "v5": function() { return /* binding */ DISCOUNT_TYPES; }
/* harmony export */ });
/* unused harmony export DiscountTypography */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87843);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);



var DiscountTypeContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")(function() {
    return {
        backgroundColor: "#F2EFF5",
        marginTop: "5px",
        padding: "1px 6px",
        width: "fit-content"
    };
});
var DiscountTypography = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "bold";
    }
})(function(param) {
    var bold = param.bold;
    return {
        color: "#5D5FEF",
        fontFamily: "Poppins",
        fontWeight: bold ? 500 : 400,
        fontSize: "12px",
        lineHeight: "19px",
        letterSpacing: "2%"
    };
});
var DISCOUNT_TYPES = {
    EXPIRATION: "EXPIRATION",
    MEKI: "MEKI"
};
var discountText = function(type) {
    switch(type){
        case DISCOUNT_TYPES.EXPIRATION:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DiscountTypography, {
                bold: false,
                children: "Descuento por vencimiento entre 2 y 6 meses"
            });
        default:
            return null;
    }
};



/***/ })

}]);